module.exports = __webpack_public_path__ + "img/energy_calculator.b5ec51cd.svg";